<script>
  import { createEventDispatcher } from "svelte";
  import UploadedImage from "../../../UploadedImage.svelte";

  const dispatch = createEventDispatcher();

  export let files;
</script>

{#if files.length}
  <div class="comment-images">
    {#each files as image, index (image)}
      <UploadedImage
        {image}
        {files}
        on:delete={() => dispatch('delete', { index })}
      />
    {/each}
  </div>
{/if}

<style lang="scss">
  .comment-images {
    display: flex;
    margin: 6px 0;
    margin-top: 6px;
    margin-bottom: 6px;

    @media (max-width: 576px) {
      display: grid;
      grid-template-columns: repeat(6, 1fr);
      grid-gap: 6px;
    }
  }
</style>